<div class="table-outer-wrapper">

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-xxs" fxLayoutGap="2%">
        <div *ngIf="tableTitle">
            <p class="upper bold-font mat-body-2" style="font-size: 20px; min-width: 100px;">{{ tableTitle }}:</p>
        </div>
        <div class="search-wrapper" fxLayout="row" fxLayoutAlign="center center"> 
            <input #filter placeholder="Wpisz szukaną frazę" class="search-bar" [formControl]="filterControl" (keyup.enter)="filterByTrigger()">
            <mat-icon class="text-primary" (click)="clearFilter()">close</mat-icon>
            <mat-icon class="text-primary" (click)="filterByTrigger()">search</mat-icon>
        </div>
        <div class="cc-table-action" fxLayout="row" fxLayoutAlign="flex-end center">
            <button type="button" (click)="addSelectedItems()" class="butt-good">
                <p class="upper">dodaj wybrane</p>
            </button>
            <button-spinner class="ml-xxs" [inProgress]="isLoadingResults">
                <button type="button" (click)="addAllItems()" class="butt-good">
                    <p class="upper">dodaj wszystkie({{ itemsLength }})</p>
                </button>
            </button-spinner>
        </div>
    </div>

    <div class="table-wrapper inner-table-wrapper">
        <inner-loader [isActive]="isLoadingResults"></inner-loader>
        <mat-table #table id="select-table"
            [dataSource]="data" class="mat-cell inner-table"
        >
        <!-- (change)="$event ? selectionModel.toggle(row) : null" -->

            <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef fxFlex="10%" fxLayout="row" fxLayoutAlign="center center">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selectionModel.hasValue() && isAllSelected()"
                        [indeterminate]="selectionModel.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="10%" fxLayout="row" fxLayoutAlign="center center" (click)="$event.stopPropagation()">
                    <mat-checkbox
                        (change)="toggleCheckbox(row)"
                        [checked]="selectionModel.isSelected(row)"
                        [disabled]="this.hasBeenUsed(row[this.idFieldName])">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container *ngFor="let column of columnSelectData" [matColumnDef]="column.columnDef">
                <mat-header-cell *matHeaderCellDef [fxFlex]="column.width">
                    <pr-drop-select [placeholder]="column.header" 
                        class="cell-header-wrapper" fxLayout="row" fxLayoutAlign="space-between center" fxFlexFill
                        [optLabel]="column.header" [selectName]="selectSortName(column)" (change)="sortChange($event)"
                        [filterDef]="column.filterValue" (filterChanged)="selFilterChanged($event)"
                        [isSelected]="checkIfSelected(column.columnDef)"></pr-drop-select>
                </mat-header-cell>
                <mat-cell *matCellDef="let row"
                    [matTooltip]="getTooltip(column, row[column.columnDef])" 
                    [fxFlex]="column.width">
                    <div *ngIf="column.type && column.type === 'date'">
                        {{ generalService.parseDate(row[column.columnDef]) || '-' }}
                    </div>
                    <div *ngIf="column.type && column.type === 'vat'" class="percentage-suf">
                        {{ generalService.parseVAT(row[column.columnDef]) | number:'.0-0' }}
                    </div>
                    <div *ngIf="!column.suffix && !column.type">
                        {{ row[column.columnDef] || "-" }}
                    </div>
                    <div *ngIf="column.type && column.type === 'margin'" class="percentage-suf">
                        {{ generalService.parseVAT(row[column.columnDef]) | number:'.1-1' }}
                    </div>
                    <div *ngIf="!column.type && column.suffix && column.suffix === 'percentage'" class="percentage-suf">
                        {{ row[column.columnDef] }}
                    </div>
                    <div *ngIf="column.suffix && column.suffix === 'currency'" class="currency-suf">
                        {{ row[column.columnDef] | number:'.2-2' }}
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef fxFlex="8%">
                    <div class="cell-header-wrapper" fxLayout="row" fxLayoutAlign="center center">
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="8%" fxLayoutAlign="center center" (click)="$event.stopPropagation()">
                    <button mat-icon-button (click)="selectRow(row)">
                        <mat-icon class="text-primary" aria-label="Delete">add</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>
            
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        
            <mat-row *matRowDef="let row; columns: displayedColumns;" 
                (click)="openDialog(row[idFieldName])"
                [class.block-item]="hasBeenUsed(row[idFieldName])" >
            </mat-row>

        </mat-table>

        <mat-toolbar>
            <mat-toolbar-row fxLayout="column">
                <!-- here select button -->

                <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 50, 100]" [length]="itemsLength" (page)="pageEvent = getPaginatorData($event)"></mat-paginator>
            </mat-toolbar-row>
        </mat-toolbar>

    </div>
    
</div>